import React, { useState } from 'react'
import { useQuery, useMutation } from 'react-apollo-hooks'
import { Text } from 'rebass'
import get from 'lodash.get'

import {
  Form,
  TextInput,
  InputGroup,
  FormSection,
} from '../Form'
import Card from '../Card'
import Loading from '../Loading'

import { updateProfileSchema } from '../../utilities/validations'
import queries from '../../queries'
import mutations from '../../mutations'
import { auth } from '../../utilities/firebase'

const Profile = () => {
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const { data, error: queryError, loading } = useQuery(queries.users.PROFILE, {
    suspend: false,
    fetchPolicy: 'network-only',
  })
  const updateProfile = useMutation(mutations.users.PROFILE)

  const onSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true)
    setError(null)
    setSuccess(null)

    const variables = {
      ...updateProfileSchema.cast(values),
      id: get(data, 'me.id', ''),
      // password must be null (not empty string) or we have yup issues on the server
      password: values.password ? values.password : null,
    }

    try {
      await updateProfile({ variables })
      setSuccess('Your account was updated')
      setTimeout(() => auth.signOut(), 500)
    } catch (e) {
      setError(e.message)
    }

    setSubmitting(false)
  }

  if (queryError && queryError.message) return <Text color="error">{queryError.message}</Text>

  return (
    <Card
      heading="Account information"
      text="If you change this information you will need to login again."
    >
      {loading
        ? <Loading />
        : (
          <Form
            initialValues={{
              firstName: get(data, 'me.firstName', ''),
              password: '',
              lastName: get(data, 'me.lastName', ''),
              email: get(data, 'me.email', ''),
            }}
            validationSchema={updateProfileSchema}
            onSubmit={onSubmit}
            success={success}
            error={error}
          >
            <FormSection>
              <InputGroup>
                <TextInput name="firstName" placeholder="First name" label="First name" />
                <TextInput name="lastName" placeholder="Last name" label="Last name" />
              </InputGroup>
              <TextInput name="email" placeholder="Email address" label="Email address" />
              <TextInput name="password" placeholder="********" label="New Password" />
            </FormSection>
          </Form>
        )
      }
    </Card>
  )
}

export default Profile
